import type { FaireProductEntity } from "../../entity_types/product";

export const p_9uar7wzusu: FaireProductEntity = {
  token: "p_9uar7wzusu",
  type: "product",
  name: "Faux Leather Bow Metal Heart Drop Keychain / Bag Charm",
  brandName: "Sensibling Corp.",
  imageUrl:
    "https://cdn.faire.com/fastly/4378a74ab17d06db18d97327770b30f90e790ceffd89c1f59a7c17e85a64c79d.jpeg",
  priceDollars: 6.33,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/daaa2e233715709cb40ea97e80393752586314d20328094efcf2b90b9c964e60.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
